<template>
  <div class="headline">
    <div class="img-grid">
      <router-link to="/">
        <img src="./img/logo.png" alt/>
      </router-link>
    </div>
    <ul>
      <li>
        <router-link to="/">首页</router-link>
      </li>
      <li>
        <router-link to="introductionProduct">产品介绍</router-link>
      </li>
      <li>
        <router-link to="trial">申请试用</router-link>
      </li>
      <li class="entrance">
        <span @mouseover="person_info()" @mouseout="cl_person_info()">赛事入口</span>
        <div
            v-show="person_con"
            class="hidden_div"
            @mouseover="person_infoContinue()"
            @mouseout="cl_person_infoContinue()"
        >
          <a href="https://pe.328ym.com/">
            <span>全国赛事</span>
          </a>
          <a href="https://www.328ym.com/athleteHtml/">
            <span>浙江省学校体育协会</span>
          </a>
          <a href="https://328ym.com/jx1Html/">
            <span>浙江省学校体协-教学</span>
          </a>
          <a href="https://www.328ym.com/athleteinnerHtml/">
            <span>内蒙古学生体育协会</span>
          </a>
          <a href="https://www.328ym.com/jsMicroHtml/">
            <span>江苏省高校体育</span>
          </a>
        </div>
      </li>

      <li style="display:none;">
        <router-link to="distributor">经销商计划</router-link>
      </li>
      <li>
        <router-link to="opportunitiesJob">工作机会</router-link>
      </li>
      <li class="second">
        <router-link to="usAbout">关于我们</router-link>
      </li>
      <li class="record">
        <a href="https://328ym.com/cmsSchoolHtml/#/login">登录</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "headline",
  data() {
    return {
      person_con: false
    };
  },
  methods: {
    person_info() {
      this.person_con = true;
    },

    cl_person_info() {
      this.person_con = false;
    },

    person_infoContinue() {
      this.person_con = true;
    },

    cl_person_infoContinue() {
      this.person_con = false;
    }
  }
};
</script>

<style lang="less" scoped>
.headline {
  height: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  width: 100%;
  z-index: 1;
  border-bottom: 0.005rem solid #fff;

  .img-grid {
    height: 0.8rem;
    margin: 0.1rem 1rem;

    img {
      cursor: pointer;
      height: 100%;
    }
  }

  ul {
    li {
      font-size: 0.2rem;
      cursor: pointer;
      font-weight: 600;
      margin-left: 0.2rem;

      a {
        color: rgba(255, 255, 255, 1);
      }

      span {
        color: #fff;
      }

      &.entrance {
        display: none;
        position: relative;

        .hidden_div {
          width: 2rem;
          left: 50%;
          top: 0;
          padding: 0.65rem 0 0 0;
          transform: translateX(-50%);
          text-align: center;
          position: absolute;
          font-size: 0.16rem;
          display: flex;
          flex-direction: column;

          &::before {
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 0.55rem;
            border-left: solid 10px transparent;
            border-right: solid 10px transparent;
            border-bottom: solid 10px #fff;
          }

          > a {
            background: #fff;
            font-weight: 400;
            padding-top: .14rem;

            > span {

              color: #333;
            }

            &:first-of-type {
              border-radius: 2px 2px 0 0;
            }

            &:last-of-type {
              border-radius: 0 0 2px 2px;
              padding-bottom: .14rem;
            }

            &:hover span {
              color: #2c6cb1;
              border-bottom: .01rem solid #2c6cb1;
            }
          }
        }
      }
    }

    .second {
      margin-right: 0.9rem;
    }

    .record {
      padding: 0.09rem 0.3rem;
      border-radius: 0.23rem;
      border: 0.01rem solid rgba(255, 255, 255, 1);
      margin-right: 1rem;
    }
  }
}

@media screen and (max-width: 1440px) {
  .record {
    margin-right: 0.5rem !important;
  }

  .second {
    margin-right: 0.4rem !important;
  }
}
</style>
